// Function to convert the date received from the backend to the Italian format
const myDateFormat = (input) => {
  if (!input) return '-';
  const date = new Date(input);
  if (isNaN(date)) return '-';
  // Format with Italian locale and explicit options
  return date.toLocaleString('it-IT', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
}

export default myDateFormat;